import moment from 'moment'
import { HOTEL_TYPE } from '@/const/hotel'
import FeedbackBlockStyles from '@/features/babysitter/components/Profile/InfoBlocks/FeedbackBlock/FeedbackBlock.styles'
import { getDaysScheduleDefaultValues } from '@/features/booking/components/Booking/BookingContainer/BookingWizardForm/helpers'
import { BOOKING_TYPE } from '@/features/bookings/consts/booking'
import { BookingModel } from '@/features/bookings/types/models'
import { AnimationChildType, ChildType } from '@/features/user'
//import { formHelper } from '@/features/profile/helpers'
import { DateUtils } from '@/utils'
import { timeToDate } from '@/utils/date'

//const { clientProfile: clientProfileHelper } = formHelper

const mapBookingTimePeriodValues = (type: BOOKING_TYPE, timetable = {}) => {
  const { time_start, time_end, same_days_time } = timetable as any

  let result: { time_start?: string; time_end?: string } = {}

  if (type === BOOKING_TYPE.ONETIME || type === BOOKING_TYPE.ANIMATION || same_days_time) {
    result = {
      time_start: time_start,
      time_end: time_end,
    }
  }

  return result
}

const mapDaysValues = (days: {}, same_days_time: boolean) => {
  let result = {}

  if (days) {
    Object.entries(days).forEach((entry) => {
      const [key, value] = entry
      const { enabled, time_start, time_end } = value as any
      let dayValue: { enabled: boolean; time_start?: string; time_end?: string } = {
        enabled: enabled,
      }

      if (enabled && !same_days_time) {
        dayValue = {
          ...dayValue,
          time_start: time_start,
          time_end: time_end,
        }
      }

      result = {
        ...result,
        [key]: dayValue,
      }
    })
  }
  return result
}

const mapDaysScheduleValues = (type: BOOKING_TYPE, timetable = {}) => {
  const { same_weeks_schedule, days_schedule, same_days_time } = timetable as any

  let result: { days_schedule?: object } = {}

  result = {
    days_schedule:
      type !== BOOKING_TYPE.ONETIME && type !== BOOKING_TYPE.ANIMATION
        ? mapDaysValues(days_schedule, same_days_time)
        : undefined,
  }

  return result
}

const mapWeeksScheduleValues = (type: BOOKING_TYPE, timetable = {}) => {
  const { same_weeks_schedule, weeks_schedule, same_days_time } = timetable as any

  let result: { weeks_schedule?: any[] } = {}

  if (type !== BOOKING_TYPE.ONETIME && type !== BOOKING_TYPE.ANIMATION && !same_weeks_schedule) {
    let values: any[] = []

    weeks_schedule.forEach((week: Array<any>) => {
      const mapWeekValues = mapDaysValues(week, same_days_time)
      values = [...values, mapWeekValues]
    })

    result = {
      weeks_schedule: values,
    }
  }

  return result
}
const mapOnetimeRangesValues = (type: BOOKING_TYPE, timetable = {}) => {
  const { onetime_ranges } = timetable as any

  let result: { onetime_ranges?: any[] } = {}
  const rangesValue = onetime_ranges.map(
    ({
      range_date_start,
      range_date_end,
      range_time_start,
      range_time_end,
      ...restItem
    }: {
      range_date_start: Date
      range_date_end: Date
      range_time_start: Date
      range_time_end: Date
    }) => ({
      ...restItem,
      range_date_start: DateUtils.formatDateToServerFormat(range_date_start),
      range_date_end: DateUtils.formatDateToServerFormat(
        type === BOOKING_TYPE.ONETIME || type === BOOKING_TYPE.ANIMATION
          ? calcEndDateOneTimeRange(range_date_start, range_time_start, range_time_end)
          : range_date_end
      ),
      range_time_start: range_time_start,
      range_time_end: range_time_end,
    })
  )

  result = {
    onetime_ranges: rangesValue,
  }
  return result
}

function calcEndDateOneTimeRange(date_start: Date, timeStart: Date, timeEnd: Date) {
  let calcDateEnd = moment(date_start)
  if (
    moment(date_start)
      .hour(moment(timeToDate(timeStart)).hour())
      .minute(moment(timeToDate(timeStart)).minute())
      .isAfter(
        moment(date_start)
          .hour(moment(timeToDate(timeEnd)).hour())
          .minute(moment(timeToDate(timeEnd)).minute())
      )
  ) {
    console.log('added one day')
    calcDateEnd = moment(date_start).add(1, 'day')
  }
  return calcDateEnd
}

const mapTimetableValues = (type: BOOKING_TYPE, timetable = {}) => {
  const { same_days_time, same_weeks_schedule, exception_dates, onetime_ranges } = timetable as any

  const bookingTimePeriodValues = mapBookingTimePeriodValues(type, timetable)

  const daysScheduleValues = mapDaysScheduleValues(type, timetable)

  const weeksScheduleValues = mapWeeksScheduleValues(type, timetable)

  const onetimeRangesValues = mapOnetimeRangesValues(type, timetable)

  return {
    ...bookingTimePeriodValues,
    same_days_time,
    same_weeks_schedule,
    exception_dates: exception_dates.map((date: Date) => DateUtils.formatDateToServerFormat(date)),
    ...daysScheduleValues,
    ...weeksScheduleValues,
    ...onetimeRangesValues,
  }
}

export const mapSubmitValues = (values = {}, frameEdit: boolean, onetime: boolean) => {
  const {
    //city_id,
    //city_type,
    //city_description,
    //country_id,
    is_hotel,
    hotel_id,
    hotel_name,
    type,
    date_start,
    date_end,
    hours_per_week,
    days_per_week,
    living_in,
    timetable,
    booking_children,
    booking_animation_children_0_2,
    booking_animation_children_3_4,
    booking_animation_children_4,
    onetime_ranges,
    has_special_needs,
    entertainment_kit,
    extra_activities,
    special_needs,
    phone,
    discount_code,
    address,
    ...restValues
  } = values as any
  /*const cityValues = clientProfileHelper.mapCitySubmitValue({
    city_id,
    city_type,
    city_description,
    country_id,
  })
*/
  const childrenValue = booking_children
    ? booking_children.map(({ birthday, ...restItem }: { birthday: Date }) => ({
        ...restItem,
        birthday: DateUtils.formatDateToServerFormat(birthday),
      }))
    : []

  let calcDateEnd = moment(onetime ? date_start : date_end)
  if (onetime) {
    if (
      moment(date_start)
        .hour(moment(timeToDate(timetable.time_start)).hour())
        .minute(moment(timeToDate(timetable.time_start)).minute())
        .isAfter(
          moment(date_start)
            .hour(moment(timeToDate(timetable.time_end)).hour())
            .minute(moment(timeToDate(timetable.time_end)).minute())
        )
    ) {
      console.log('added one day')
      calcDateEnd = moment(date_start).add(1, 'day')
    }
  }
  let result = {
    ...restValues,
    //...cityValues,
    is_hotel,
    hotel_name: is_hotel && hotel_id == HOTEL_TYPE.OTHER ? hotel_name : '',
    type,
    hours_per_week,
    discount_code,
    days_per_week,
    living_in,
    date_start: DateUtils.formatDateToServerFormat(date_start),
    date_end: DateUtils.formatDateToServerFormat(calcDateEnd),
    timetable: mapTimetableValues(type, timetable),
    booking_children: frameEdit ? childrenValue : [],
    booking_animation_children_0_2,
    booking_animation_children_3_4,
    booking_animation_children_4,
    has_special_needs,
    entertainment_kit,
    extra_activities: type == BOOKING_TYPE.ANIMATION ? extra_activities : null,
    special_needs: has_special_needs ? special_needs : '',
    address: frameEdit ? address : '',
    phone,
  }

  if (living_in) {
    result.hours_per_week = null
  } else {
    result.days_per_week = null
  }
  if (hotel_id !== HOTEL_TYPE.OTHER) {
    result = {
      ...result,
      hotel_id,
    }
  }

  return result
}

export const mapSubmitValuesCareDetails = (values = {}) => {
  const {
    booking_children,
    booking_animation_children_0_2,
    booking_animation_children_3_4,
    booking_animation_children_4,
    has_special_needs,
    special_needs,
    entertainment_kit,
    extra_activities,
    phone,
    address,
    contact_email,
    first_name,
    booking_id,
    care_expectations,
  } = values as any
  const childrenValue = booking_children.map(({ birthday, ...restItem }: { birthday: Date }) => ({
    ...restItem,
    birthday: DateUtils.formatDateToServerFormat(birthday),
  }))

  return {
    care_expectations,
    booking_id,
    booking_children: childrenValue,
    booking_animation_children_0_2,
    booking_animation_children_3_4,
    booking_animation_children_4,
    phone,
    has_special_needs,
    entertainment_kit,
    extra_activities:
      extra_activities.balloon_modeling || extra_activities.facial_painting
        ? extra_activities
        : null,
    address,
    contact_email,
    first_name,
    special_needs: has_special_needs ? special_needs : '',
  }
}

export const mapDefaultValuesFromPreviousRequest = (
  previousRequest: any,
  bookingType: BOOKING_TYPE,
  initialValuesBooking: any,
  initialValuesDetails: any
) => {
  return {
    ...initialValuesBooking?.general,
    ...initialValuesDetails?.general,
    first_name: '',
    last_name: '',
    email: '',

    lat: previousRequest.lat,
    lng: previousRequest.lng,
    is_hotel: previousRequest.is_hotel,
    hotel_id: previousRequest.hotel_id,
    zip: previousRequest.zip,
    type: bookingType,
    date_start: null,
    date_end: null,
    hours_per_week: previousRequest.hours_per_week,
    days_per_week: previousRequest.days_per_week,
    living_in: previousRequest.living_in,
    timetable: {
      time_start: null,
      time_end: null,
      same_weeks_schedule: false,
      same_days_time: false,
      weeks_schedule: [],
      days_schedule: getDaysScheduleDefaultValues(),
      exception_dates: [],
      onetime_ranges: [],
      ...initialValuesBooking?.timetable,
    },
    booking_children:
      bookingType !== BOOKING_TYPE.ANIMATION ? previousRequest.booking_children : [],
    booking_animation_children_0_2:
      bookingType === BOOKING_TYPE.ANIMATION ? previousRequest.booking_animation_children_0_2 : [],
    booking_animation_children_3_4:
      bookingType === BOOKING_TYPE.ANIMATION ? previousRequest.booking_animation_children_3_4 : [],
    booking_animation_children_4:
      bookingType === BOOKING_TYPE.ANIMATION ? previousRequest.booking_animation_children_4 : [],
    primary_language_id: previousRequest.primary_language_id,
    secondary_language_id: previousRequest.secondary_language_id,
    entertainment_kit: previousRequest.entertainment_kit,
    extra_activities: previousRequest.extra_activities,
    has_special_needs: previousRequest.has_special_needs,
    special_needs: previousRequest.special_needs || '',
    care_expectations: previousRequest.care_expectations,
    discount_code: null,
  }
}

export const mapDefaultValuesFromWorkingBooking = (
  loadedWorkingBooking: any,
  bookingType: BOOKING_TYPE,
  initialValuesBooking: any,
  initialValuesDetails: any,
  lang: any
) => {
  return {
    first_name: '',
    last_name: '',
    email: '',
    lat: 0,
    lng: 0,
    is_hotel: false,
    hotel_id: null,
    zip: '',
    type: bookingType,
    living_in: false,
    hours_per_week: null,
    days_per_week: null,
    booking_children: [],
    booking_animation_children_0_2: [],
    booking_animation_children_3_4: [],
    booking_animation_children_4: [],
    primary_language_id: lang == 'en' ? 2 : 1,
    secondary_language_id: null,
    has_special_needs: false,
    entertainment_kit: false,
    extra_activities: null,
    phone: null,
    care_expectations: '',
    discount_code: null,

    ...initialValuesBooking?.general,
    ...initialValuesDetails?.general,
    ...loadedWorkingBooking,
    date_start:
      loadedWorkingBooking.date_start == null ? null : new Date(loadedWorkingBooking.date_start),
    date_end:
      loadedWorkingBooking.date_end == null ? null : new Date(loadedWorkingBooking.date_end),
    timetable: {
      time_start: loadedWorkingBooking.timetable.time_start,
      time_end: loadedWorkingBooking.timetable.time_end,
      same_weeks_schedule: loadedWorkingBooking.timetable.same_weeks_schedule,
      same_days_time: loadedWorkingBooking.timetable.same_days_time,
      weeks_schedule: loadedWorkingBooking.timetable.weeks_schedule,
      days_schedule: loadedWorkingBooking.timetable.days_schedule,
      exception_dates: loadedWorkingBooking.timetable.exception_dates,
      onetime_ranges: createOneTimeRangesFromStorage(loadedWorkingBooking.timetable.onetime_ranges),
    },
  }
}

export const mapDefaultValuesFromSavedBooking = (
  booking: BookingModel,
  initialValuesBooking: any,
  initialValuesDetails: any
) => {
  return {
    ...initialValuesBooking,
    ...initialValuesDetails,
    is_hotel: booking.is_hotel,
    hotel_id: booking.hotel_id,
    hotel_name: booking.hotel_name,
    zip: booking.zip,
    type: booking.type,
    living_in: booking.living_in,
    hours_per_week: booking.hours_per_week,
    days_per_week: booking.days_per_week,
    booking_children: booking.booking_children,
    primary_language_id: booking.primary_language?.id,
    secondary_language_id: booking.secondary_language ? booking.secondary_language.id : undefined,
    has_special_needs: booking.has_special_needs || false,
    special_needs: booking.special_needs,
    phone: booking.phone,
    care_expectations: booking.care_expectations,
    discount_code: booking.discount_code,
    date_start: booking.date_start ? new Date(booking.date_start) : null,
    date_end: booking.date_end ? new Date(booking.date_end) : null,
    address: booking.address,
    comments: booking.comments,
    contact_email: booking.contact_email,
    lat: booking.lat,
    lng: booking.lng,

    booking_animation_children_0_2: booking.animation_details?.booking_animation_children_0_2,
    booking_animation_children_3_4: booking.animation_details?.booking_animation_children_3_4,
    booking_animation_children_4: booking.animation_details?.booking_animation_children_4,
    entertainment_kit: booking.animation_details?.entertainment_kit,
    extra_activities: {
      facial_painting: booking.animation_details?.extra_activities?.facial_painting,
      balloon_modeling: booking.animation_details?.extra_activities?.balloon_modeling,
      hours: booking.animation_details?.extra_activities?.hours
        ? parseInt(booking.animation_details?.extra_activities?.hours)
        : 0,
    },

    timetable: {
      time_start: booking.timetable.time_start,
      time_end: booking.timetable.time_end,
      same_weeks_schedule: booking.timetable.same_weeks_schedule,
      same_days_time: booking.timetable.same_days_time,
      weeks_schedule: booking.timetable.weeks_schedule || [],
      days_schedule: booking.timetable.days_schedule || getDaysScheduleDefaultValues(),
      exception_dates: createExceptionDatesFromSaved(booking.timetable.exception_dates),
      onetime_ranges: createOneTimeRangesFromStorage(booking.timetable.onetime_ranges),
    },
  }
}

function createOneTimeRangesFromStorage(onetime_ranges: any) {
  const result = [] as any[]
  if (onetime_ranges) {
    onetime_ranges.map((item: any) => {
      result.push({
        range_date_start: item.range_date_start,
        range_date_end: item.range_date_end,
        range_time_start: item.range_time_start,
        range_time_end: item.range_time_end,
      })
    })
  }
  return result
}

function createExceptionDatesFromSaved(exception_dates: any) {
  const result = [] as any[]
  if (exception_dates) {
    exception_dates.map((item: any) => {
      result.push(new Date(item))
    })
  }
  return result
}

export function ageMean(booking_children: ChildType[]) {
  let total = 0
  let result = 0
  if (booking_children) {
    booking_children.map((item: ChildType) => {
      total += getAge(item.birthday)
    })
    result = total / booking_children.length
  }
  return result
}
export function ageMeanAnimation(
  booking_animation_children_0_2: AnimationChildType[],
  booking_animation_children_3_4: AnimationChildType[],
  booking_animation_children_4: AnimationChildType[]
) {
  let total = 0
  let result = 0
  if (booking_animation_children_0_2) {
    booking_animation_children_0_2.map((item: AnimationChildType) => {
      total += parseInt(item.kid_age) < 12 ? 0 : parseInt(item.kid_age) == 12 ? 1 : 2
    })
  }
  if (booking_animation_children_3_4) {
    booking_animation_children_3_4.map((item: AnimationChildType) => {
      total += parseInt(item.kid_age)
    })
  }
  if (booking_animation_children_4) {
    booking_animation_children_4.map((item: AnimationChildType) => {
      total += parseInt(item.kid_age)
    })
  }
  result =
    total /
    (booking_animation_children_0_2.length +
      booking_animation_children_3_4.length +
      booking_animation_children_4.length)
  return result
}

function getAge(dateString: string) {
  const today = new Date()
  const birthDate = new Date(dateString)
  let age = today.getFullYear() - birthDate.getFullYear()
  const m = today.getMonth() - birthDate.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}
